import axios from "axios";
import { config } from "../enviroment";
import {history} from "../helpers/history";
import {routePaths} from "../components/config/route-paths";
import {apolloClientService} from './apollo-client';
export const authService = {
  accountDetais,
  accountDetaisAfterLogin
};

async function accountDetais() {
  let tenantCode = config.constants.BASE_TENANT_CODE;
  let bearer = localStorage.getItem("bearer");       
  let accountId = null;  
  let accesstoken = null;

   if (bearer) {   
     bearer = JSON.parse(bearer); 
     accountId =bearer.accountDetails.indentifiers.accountId[0]; 
     accesstoken = bearer.acessToken
  }
  const GET_CONTENT=`{getAccountDetails(input:{tenantCode:"` +
  tenantCode +`",accountId:"` + accountId +`"})}`
  let res= await apolloClientService.ApolloClientgqlsAuth(GET_CONTENT,"","network-only")
  return res.data.getAccountDetails;

  // let APIquery =
  //   `{getAccountDetails(input:{tenantCode:"` +
  //   tenantCode +
  //   `",accountId:"` +
  //   accountId +
  //   `"})}`;
  // return new Promise((resolve, reject) => {
  //   axios({
  //     url: config.urls.AUTH_SERVICE,
  //     method: "post",
  //     data: {
  //       query: APIquery,
  //     }
  //   })
  //     .then(function(response) {
  //      resolve(response.data.data.getAccountDetails)
  //     })
  //     .catch(function(error) {
  //       // if(!error.response){
  //       //   history.push(routePaths.RETRY)
  //       // }
  //       // else if(error.response && error.response.status === 500 || error.response.status=== 404 ){
  //       //   history.push(routePaths.RETRY)
  //       // }
  //       reject(error);
  //     });
  // });
}

async function accountDetaisAfterLogin() {
  let tenantCode = config.constants.BASE_TENANT_CODE;
  let bearer = localStorage.getItem("bearer");       
  let accountId = null;  
  let accesstoken = null;
  let personId=null;

   if (bearer) {   
     bearer = JSON.parse(bearer); 
     accountId =bearer.accountDetails.indentifiers.accountId[0]; 
     accesstoken = bearer.acessToken
     personId=bearer.personId
  }
  const GET_CONTENT=`{getAccountDetailsAfterLogin(input:{tenantCode:"` +
  tenantCode +`",accountId:"` + accountId +`",personId:"`+personId+`"})}`
  //let res= await apolloClientService.ApolloClientgqlsAuth(GET_CONTENT,"","network-only")
 // return res.data.getAccountDetailsAfterLogin;
  const res = await axios.post(config.urls.AUTH_SERVICE,{
      query:GET_CONTENT
  })

 // console.log(res,'api call resp')
  return res.data.data.getAccountDetailsAfterLogin;

}
